export function isMobileBrowser() {
    return window.innerWidth <= 480;
}
